import React from "react";
import styles from "../PolicyBuilder.module.scss";
import classNames from "classnames";

export const SectionHeader: React.FC<{ index?: number; title: string; description: string; className?: string; children?: React.ReactNode }> = ({
  index,
  title,
  description,
  className,
  children,
}) => {
  return (
    <div className={classNames(styles.contentHeader, className)}>
      <div className={styles.sectionTitleWrap}>
        {index && <span className={styles.sectionNumber}>{index}</span>}
        <div className={styles.sectionTitleText}>
          <div className={styles.sectionTitleRow}>
            <h3>{title}</h3>
          </div>
          <p>{description}</p>
        </div>
      </div>
      {children}
    </div>
  );
};
